import { render } from "./BookMore.vue?vue&type=template&id=52598356&scoped=true"
import script from "./BookMore.vue?vue&type=script&lang=js"
export * from "./BookMore.vue?vue&type=script&lang=js"

import "./BookMore.vue?vue&type=style&index=0&id=52598356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52598356"]])

export default __exports__